import React from 'react';
import Projeto from '../Projeto';
import styled from 'styled-components';

const Container = styled.div`
  padding: 20px;
  width: 70%;
  margin-left: 80px;
  @media (max-width: 768px) {
    width: 100%;
    margin-left: 0px;
    padding: 0px;
  }
`;

const Title = styled.h1`
  font-size: 60px;
  margin-bottom: 1rem;
  border-bottom: 1px solid #616777;
  font-family: 'NTR', sans-serif;
  @media (max-width: 768px) {
    font-size: 40px;
    text-align: center;
  }
`;

const Description = styled.p`
  font-size: 18px;
  margin-bottom: 2rem;
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const DescriptionBox = styled.p`
  padding: 30px;
  border-radius: 8px;
  background-color: aliceblue;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 2rem;
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
`;

const ProjetoCard = styled.div`
  width: 90%;
  margin: 0;
  padding: 1rem;
  border-radius: 10px;
`;

const Projetos = () => {
  const projetos = [
    {
      titulo: 'Circuito',
      descricao: 'Plataforma publica para calendario de corridas de rua e trilhas na Paraiba, com busca, filtros, eventos em destaque, detalhes de provas e conteudo de blog.',
      liveLink: 'https://circuitoapp.com.br/'
    },
    {
      titulo: 'Triangle',
      descricao: 'Aplicacao React para gestao organizacional, com cadastro e manipulacao de usuarios, customizacao de interface e componentizacao.',
      repoLink: 'https://github.com/fgrdz/Triangle'
    },
    {
      titulo: 'Dogtech',
      descricao: 'Blog em React com rotas, estrutura multipaginas e organizacao de componentes para evolucao de conteudo.',
      repoLink: 'https://github.com/fgrdz/dogtech'
    },
    {
      titulo: 'Landing',
      descricao: 'Landing page em TypeScript com Tailwind CSS e Shadcn, focada em responsividade e componentes reutilizaveis.',
      repoLink: 'https://github.com/fgrdz/landing'
    },
    {
      titulo: 'Translator',
      descricao: 'Aplicacao React integrada a uma API gratuita de traducao, com consumo de dados assincrono e suporte a diversos idiomas.',
      repoLink: 'https://github.com/fgrdz/translator'
    },
    {
      titulo: 'Insulin reminder',
      descricao: 'Projeto Next.js com AWS para cadastro de lembretes diarios de insulina e envio automatizado via WhatsApp.',
      repoLink: 'https://github.com/fgrdz/insulin-reminder'
    },
    {
      titulo: 'Psi. Carolina Porto',
      descricao: 'Site profissional responsivo com apresentacao de servicos, abordagem, blog, avaliacoes e conteudo institucional.',
      liveLink: 'https://www.psicarolinaporto.com/'
    }
  ];

  return (
    <Container id="projetos">
      <Title>Projetos</Title>
      <Description>Aqui estao alguns projetos pessoais, estudos e entregas web que desenvolvi:</Description>
      <Grid>
        {projetos.map((projeto) => (
          <ProjetoCard key={projeto.titulo}>
            <Projeto
              titulo={projeto.titulo}
              descricao={projeto.descricao}
              repoLink={projeto.repoLink}
              liveLink={projeto.liveLink}
            />
          </ProjetoCard>
        ))}
      </Grid>
      <DescriptionBox>
        No meu GitHub voce encontra mais projetos pessoais, estudos e experimentos tecnicos.
        No LinkedIn voce pode acompanhar minhas atividades profissionais e evolucao em engenharia de software.
      </DescriptionBox>
    </Container>
  );
};

export default Projetos;
